var map = {
	"./default-artpiece.jpeg": 589,
	"./default-image.jpeg": 109,
	"./hero-event.webp": 453,
	"./logo-horizontal.png": 209,
	"./texture.jpeg": 943,
	"./white-logo.png": 562
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 190;